



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import '../assets/css/ServiceRequestDetails.scss';
import {GPSLocation, Invoice, RequestStatus, Route, ServiceRequest} from '../types/entity';
import {ApiRequest, CancelRequest, Document, EditParticipantRequest} from '../types/request';
import {MedTransGoConstants} from '../util/constants';
import {ObjectFactory} from '../config/objectFactory';
import {DateUtils} from '../util/dateUtils';
import GoogleMap from '../components/GoogleMap.vue';
import RescheduleRequestModal from './modal/RescheduleRequestModal.vue';
import EditServiceRequestModal from './modal/EditServiceRequestModal.vue';
import MessageBox from '../components/MessageBox.vue';
import {email, required} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import {MathUtils} from '@/util/mathUtils';
import {InterpreterProfile, MemberProfile} from '@/types/response';
import BaseCard from '../components/BaseCard.vue';
import CardCell from '../components/CardCell.vue';
import Dropdown from '../components/Dropdown.vue';
import FareDetails from '../components/FareDetails.vue';
import ApproveAuctionModal from './modal/ApproveAuctionModal.vue';
import UploadLienCustomerDocument from '../views/modal/UploadLienCutomerDocument.vue';
import ViewFeedbackModal from '../views/modal/ViewFeedbackModal.vue';
import {CommonUtils} from '@/util/commonUtils';
import DataTable from '@/components/DataTable.vue';
import ViewLienDocumentModal from './modal/ViewLienDocumentModal.vue';
import { ToastEvent } from '@/types/event';
import { EventBus } from '@/main';
// tslint:disable-next-line:no-var-requires
const LienDocumentTable = require('../datatable/LienDocumentTable.json');
// tslint:disable-next-line:no-var-requires
const PartnerAvailabilityTable = require('../datatable/PartnerAvailabilityTable.json');

@Component({
    mixins: [validationMixin],
    props: {
        id: String,
    },
    components: {
        GoogleMap,
        RescheduleRequestModal,
        MessageBox,
        BaseCard,
        CardCell,
        Dropdown,
        ApproveAuctionModal,
        FareDetails,
        UploadLienCustomerDocument,
        ViewFeedbackModal,
        DataTable,
        ViewLienDocumentModal,
        EditServiceRequestModal,
    },
    data() {
        return {
            cancellationReason: '',
            reasons: [
                { value: 'R00009', text: 'Appointment Rescheduled' },
                { value: 'R00011', text: 'Incorrect Pick up address provided' },
                { value: 'R00010', text: 'Passenger Provided Own Transportation' },
                { value: 'R00012', text: 'Passenger Refused Transportation' },
                { value: 'R00008', text: 'Passenger Unreachable' },
            ],
            interpretationReasons: [
                { value: 'I00001', text: 'Appointment rescheduled' },
                { value: 'I00002', text: 'Patient unreachable/No-Show' },
                { value: 'I00003', text: 'Patient provided own Interpreter' },
                { value: 'I00004', text: 'Facility No-Show (Virtual Only)' },
                { value: 'I00005', text: 'Incorrect Appointment Date/Time selected' },
                { value: 'I00006', text: 'Wrong Language Selected' },
                { value: 'I00007', text: 'Interpreter No-Show' },
            ],
            comments: '',
            participantEmail: '',
            blobURL: '',
            activeTabIndex: 0,
            showSignowPopup: false,
            documentSigningLink: '',
            joinLink: '',
            showPartnerAvailabilityResponses: false,
            patientPickedUp: false,
        };
    },
    validations: {
        cancellationReason: {
            required,
        },
        participantEmail: {
            email,
        },
        joinLink: {
            required,
        },
    },
    watch: {
        'id'(newId) {
            const obj = this as ServiceRequestDetails;
            obj.getRequestDetails(true);
        },
        '$route.path'(to, from) {
            if (!to.endsWith(MedTransGoConstants.URL_RESCHEDULE_REQUEST)
                && !to.includes(MedTransGoConstants.URL_NEW_SERVICE_REQUEST)) {
                const obj = this as ServiceRequestDetails;
                obj.getRequestDetails(true);
            }
        },
        'serviceRequest.interpreterRequest'(newType) {
            this.$data.cancellationReason = '';
        },
    },
})
export default class ServiceRequestDetails extends Vue {

    private serviceRequest: ServiceRequest = {
        additionalNotes: '',
        rxAdditionalNotes: '',
        appointment: {
            additionalNotes: '',
            date: '',
            facility: {
                name: '',
                email: '',
                address: {},
            },
            coordinator: {
                name: '',
                email: '',
                phone: '',
            },
            patient: {
                fullName: '',
                email: '',
                phone: '',
                address: {},
            },
            timestamp: '',
            timezone: '',
        },
        assignment: {
            history: [],
        },
        billingLocation: {
            address: {},
            name: '',
        },
        createdOn: '',
        payment: {},
        status: '',
        transportRequest: {
            conciergeService: false,
            estimatedVisitTime: { hours: '', minutes: '' },
            routes: [],
            transport: '',
            vehicleType: '',
            visitType: '',
            isBariatricServiceRequired: '',
            isWheelchairProvided: '',
            driverGenderPreference: '',
            providedWheelchairOption: '',
        },
        id: '',
        pickupAddressCoordinates: {
            lat: 0,
            lng: 0,
        },
        dropoffAddressCoordinates: {
            lat: 0,
            lng: 0,
        },
        isPatientPaySelected: false,

    } as any;
    private DateUtils = DateUtils;
    private cancelEvent = false;
    private showCancelationReasonModal = false;
    private cancellationReason = null;
    private currentStatus: RequestStatus = 'Pending';
    private requestStatusArray: RequestStatus[] = [];
    private currentStatusTimestamp = '';
    private currentStatusIndex: number = 0;
    private showInvoice = false;
    private MathUtils = MathUtils;
    private showChangeInterpreterConfirmation = false;
    private depositAmount = 0;
    private isFormValid = false;
    private showFeedback = false;
    private participants: string[] = [];
    private invoice: Invoice | null = null;
    private intervalID: any = null;
    private mapRoutes: Route[] = [
        {
            pickupAddress: {
                fullAddress: '',
                latitude: 0,
                longitude: 0,
                zip: '',
                country: '',
                city: '',
                state: '',
                locality: '',
                timezone: '',
            },
            dropoffAddress: {
                fullAddress: '',
                latitude: 0,
                longitude: 0,
                zip: '',
                country: '',
                city: '',
                state: '',
                locality: '',
                timezone: '',
            },
            totalMiles: 0,
            duration: 0,
            fare: {
                particulars: [],
                totalAmount: 0,
            } as any,
            pickupTime: 0,
            expectedArrivalTime: 0,
            estimatedPayout: 0,
            status: '',
            createdOn: '' as any,
            lastModifiedOn: 0,
            transporterId: '',
            driverId: '',
            driverName: '',
            id: '',
            transporterCompany: '',
            googleMap: {},
            routeId: '',
        } as any,
    ];
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private isLoading = true;
    private isRouteLoading = true;
    private isRouteRefreshing = false;
    private showUploadDocumentForm = false;
    private completedRouteDetails = [] as any ;
    private showRoutePolyLine = false;
    private blurRequestDetails = false;
    private interpreterProfile: InterpreterProfile = {} as any;
    private requestEvents = [] as any;
    private lienDocumentTable = LienDocumentTable;
    private partnerAvailabilityTable = PartnerAvailabilityTable;
    private selectedDocument: Document | null = null;
    private dialogVisible = false;
    private  acknowledged = false;
    private confirmUpdateLink = false;
    private driverLocation: GPSLocation = {} as any;
    private showRescheduleRequestModal = false;
    private showEditRequestModal = false;
    private activeTab = false;
    private selectedTextMessage = '';
    private showTextMessagePopup = false;
    private pickUpAddressState = '';

    public async mounted() {
        const id = this.$props.id || this.$route.params.id;
        if (id) {
            await this.getRequestDetails(true);
        }
        if (this.memberProfile.isRestrictedView !== undefined && this.memberProfile.isRestrictedView) {
            this.blurRequestDetails = true;
        }
        this.validateForm();
        setInterval(() => this.getRequestDetails(false), 10000);
    }

    get inProgressRoute() {
        if (this.mapRoutes && this.mapRoutes.length) {
            for (const route of this.mapRoutes) {
                if (route.status === 'In-Progress' && route.tripDetails) {
                    this.$data.pickupAddressCoordinates = {
                        lat: route.pickupAddress.latitude,
                        lng: route.pickupAddress.longitude,
                    };
                    this.$data.dropoffAddressCoordinates = {
                        lat: route.dropoffAddress.latitude,
                        lng: route.dropoffAddress.longitude,
                    };
                    return route;
                }
            }
        }
        return null;
    }

    get rideShareUrl() {
        if (this.mapRoutes && this.mapRoutes.length) {
            for (const route of this.mapRoutes) {
                if (route.rideShareDetails && route.rideShareDetails.routeUrl && route.status === 'In-Progress') {
                    return route.rideShareDetails.routeUrl;
                }
            }
        }
        return null;
    }

    private async refreshRouteLocation() {
        let googleMap = this.$refs.liveLocationMap as any;
        if (!googleMap) {
            googleMap = this.$refs.liveLocationMap as any;
        }
        if (this.inProgressRoute) {
            const iHttpService = ObjectFactory.getHttpService();
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_ROUTES}/${this.inProgressRoute.id}`,
            };
            this.isRouteRefreshing = true;
            const response = await iHttpService.get<Route>(apiRequest);
            this.isRouteRefreshing = false;
            if (response.success && response.data) {
                const route = response.data;
                const existingRoute = this.mapRoutes.find((value) => {
                    return value.id === route.id;
                });
                if (existingRoute) {
                    existingRoute.status = route.status;
                    existingRoute.tripDetails = route.tripDetails;

                    if (route.tripDetails && route.tripDetails.driverLocation && googleMap) {
                        if (route.tripDetails.patientPickedUpAt) {
                            this.$data.patientPickedUp = true;
                        }
                        this.animateCarIcon(
                            this.driverLocation,
                            route.tripDetails.driverLocation,
                            (newPosition) => {
                                googleMap.updateLocation(newPosition);
                            },
                        );
                        // Update the last known driver location
                        this.$data.driverLocation = route.tripDetails.driverLocation;
                    }
                }
            }
        }
    }
    private async getRequestInvoice() {
        const requestId = this.$props.id || this.$route.params.id;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${requestId}/invoice`,
        };
        const iHttpService = ObjectFactory.getHttpService();
        const response: any = await iHttpService.get<Invoice>(apiRequest);
        if (response.success && response.data) {
            this.invoice = response.data;
        }
    }

    private async getRequestDetails(showLoader: boolean) {
        const id = this.$props.id || this.$route.params.id;
        if (id) {
            this.depositAmount = 0;
            if (showLoader) {
                this.isLoading = true;
                this.isRouteLoading = true;
            } else {
                this.isLoading = false;
                this.isRouteLoading = false;
            }
            const response = await ObjectFactory.getRequestService().getRequestDetails(id,
                this.$store.state.serverUrl, this.isLoading);
            this.isLoading = false;
            if (response.data) {
                if (!response.data.payment || !response.data.payment.invoiceId) {
                    this.getRequestInvoice();
                }
                if (response.data.transportRequest
                    && response.data.transportRequest.rideshareService
                    && response.data.status === 'Pending') {
                    response.data.assignment.history.push({
                        status: 'Assigned',
                        timestamp: response.data.createdOn as number,
                        userId: '',
                    });
                    response.data.assignment.history.push({
                        status: 'Confirmed',
                        timestamp: response.data.createdOn as number,
                        userId: '',
                    });
                }
                const assignmentHistory = response.data.assignment.history;
                if (response.data.assignment && response.data.assignment.interpreterId) {
                    const interpreterId = response.data.assignment.interpreterId;
                    const iHttpService = ObjectFactory.getHttpService();
                    const apiRequest: ApiRequest = {
                        baseURL: this.$store.state.serverUrl,
                        url: `${MedTransGoConstants.HTTP_URL_INTERPRETERS}/${interpreterId}`,
                    };
                    const interpreterResponse = await iHttpService.get<InterpreterProfile>(apiRequest);
                    if (interpreterResponse.success && interpreterResponse.data) {
                        this.interpreterProfile = interpreterResponse.data;
                    } else {
                        CommonUtils.showError(interpreterResponse);
                    }
                }
                if (response.data.assignment.rejectedInvitees && response.data.assignment
                      .rejectedInvitees.some((invitee) => invitee.partnerAvailabilityTime)) {
                    this.$data.showPartnerAvailabilityResponses = true;
                    this.partnerAvailabilityTable.data = [];
                    response.data.assignment.rejectedInvitees.forEach((invitee) => {
                        if (invitee.partnerAvailabilityTime) {
                          this.partnerAvailabilityTable.data.push({
                            name: invitee.transporterName,
                            availabilityTime: invitee.partnerAvailabilityTime,
                          });
                        }
                    });
                }
                let isLienRequest = false;
                if (response.data.transportRequest && response.data.transportRequest.lienRequest) {
                    isLienRequest = true;
                }
                if (response.data.status === 'Canceled') {
                    this.requestStatusArray = ['Pending'];
                    assignmentHistory.forEach((history) => {
                        if (!this.requestStatusArray.includes(history.status)) {
                            this.requestStatusArray.push(history.status);
                        }
                    });
                } else if (isLienRequest) {
                    this.requestStatusArray = ['Documents Sent', 'Documents Signed', 'Pending',
                        'Confirmed', 'Completed'];
                } else {
                    this.requestStatusArray = ['Requires Approval', 'Pending', 'Confirmed', 'Completed'];
                }
                if (response.data.transportRequest && response.data.transportRequest.lienRequest &&
                        response.data.status === 'Pending') {
                        const lienRequest = response.data.transportRequest.lienRequest;
                        const lienRequestStatus = lienRequest.status;
                        const documents = lienRequest.documents || [];
                        const areAllDocumentsVerified =
                            documents.length > 0 && documents.every((doc) => doc.verified === true);
                        if (lienRequestStatus === 'Pending') {
                            this.currentStatus = areAllDocumentsVerified ? 'Documents Signed' : 'Documents Sent';
                            this.currentStatusIndex = areAllDocumentsVerified ? 1 : 0;
                        } else if (lienRequestStatus === 'Approved' && areAllDocumentsVerified) {
                            this.currentStatus = 'Pending';
                            this.currentStatusIndex = 2;
                        }
                } else {
                    const statusMap: { [key: string]: { label: string; index: number } } = {
                        'Requires Approval': { label: 'Requires Approval', index: 0 },
                        'Pending': { label: 'Pending', index: 1 },
                        'Confirmed': { label: 'Confirmed', index: isLienRequest ? 3 : 2 },
                        'Completed': { label: 'Completed', index: isLienRequest ? 4 : 3 },
                    };

                    const mappedStatus = statusMap[response.data.status];
                    if (mappedStatus) {
                        this.currentStatus = mappedStatus.label as any;
                        this.currentStatusIndex = mappedStatus.index;
                    }
                }
                if (response.data.payment && response.data.payment.invoiceId) {
                    const invoiceResponse = await ObjectFactory.getRequestService()
                        .getRequestInvoice(response.data.payment.invoiceId,
                            this.$store.state.serverUrl, this.isLoading);
                    response.data.payment.invoice = invoiceResponse.data;
                    this.showInvoice = true;
                } else {
                    if (response.data.payment) {
                        if (response.data.payment.estimatedFare) {
                            const estimatedFare = response.data.payment.estimatedFare;
                            estimatedFare.particulars.forEach((element) => {
                                if (element.description === 'Deposit (Refundable)') {
                                    this.depositAmount += element.amount;
                                }
                            });
                        }
                    }
                }
                if (response.data.transportRequest) {
                    this.mapRoutes = response.data.transportRequest.mapRoutes;
                    response.data.transportRequest.isOxygenTankRequired =
                        response.data.transportRequest.isOxygenTankRequired ? 'Yes' : 'No' as any;
                    response.data.transportRequest.mentalHealth =
                        response.data.transportRequest.mentalHealth ? 'Yes' : 'No' as any;
                    response.data.transportRequest.caregiver =
                        response.data.transportRequest.caregiver ? 'Yes' : 'No' as any;
                    response.data.transportRequest.isBariatricServiceRequired =
                        response.data.transportRequest.isBariatricServiceRequired ? 'Yes' : 'No' as any;
                    response.data.transportRequest.isWheelchairProvided =
                        response.data.transportRequest.isWheelchairProvided ? 'Yes' : 'No' as any;
                    response.data.transportRequest.rideshareService =
                        response.data.transportRequest.rideshareService ? 'Yes' : 'No' as any;
                    for (const route of this.mapRoutes) {
                        if (route.pickupAddress.pickupInstructionImageResourceId) {
                            route.pickupAddress.pickupInstructionImageResourceId =
                                await this.getResource(route.pickupAddress.pickupInstructionImageResourceId);
                        }
                        if (route.dropoffAddress.dropoffInstructionImageResourceId) {
                            route.dropoffAddress.dropoffInstructionImageResourceId = await this.getResource
                                (route.dropoffAddress.dropoffInstructionImageResourceId);
                        }
                        if (route.status === 'In-Progress' && route.tripDetails) {
                            if (this.intervalID) {
                                clearInterval(this.intervalID);
                            }
                            this.intervalID = setInterval(this.refreshRouteLocation, 25000);
                            if (route.tripDetails.driverLocation) {
                                this.driverLocation = route.tripDetails.driverLocation;
                            }
                            break;
                        }
                    }
                    if (this.mapRoutes && this.mapRoutes[0].pickupAddress && this.mapRoutes[0].pickupAddress.state) {
                        this.pickUpAddressState = this.mapRoutes[0].pickupAddress.state;
                    }
                    await this.getLienRequestDocuments(false);
                }
                if (response.data.deliveryRequest) {
                    this.mapRoutes = response.data.deliveryRequest.mapRoutes;
                }
                this.serviceRequest = response.data;
                this.getCustomerLog();
                if (response.data.cmrRequest) {
                    this.serviceRequest.serviceType = 'Comprehensive Medication Review';
                }
                if (response.data.homeAssistanceRequest && this.serviceRequest.homeAssistanceRequest) {
                    this.serviceRequest.serviceType = `${this.serviceRequest.serviceType} + Home Assistance`;
                    const appointmentTimestamp =
                        DateUtils.convertToUTCInMillis(response.data.homeAssistanceRequest.appointmentDate + ' ' +
                            response.data.homeAssistanceRequest.appointmentTime, response.data.appointment.timezone);
                    const appointmentTime = DateUtils.formatDate(appointmentTimestamp,
                        DateUtils.FORMAT_DATETIME_AM_PM, response.data.appointment.timezone);
                    this.serviceRequest.homeAssistanceRequest.appointmentDate = appointmentTime;
                }
                if (this.serviceRequest.deliveryRequest && this.serviceRequest.deliveryRequest.proofOfDelivery) {
                    this.getProofOfDelivery(this.serviceRequest.deliveryRequest.proofOfDelivery);
                }
                if (response.data.status === 'Completed') {
                    if (response.data.transportRequest && response.data.transportRequest.mapRoutes) {
                        let index = 0;
                        response.data.transportRequest.routes.forEach(async (route: Route) => {
                            const routeId = route.routeId;
                            const apiRequest: ApiRequest = {
                                baseURL: this.$store.state.serverUrl,
                                url: `${MedTransGoConstants.HTTP_URL_ROUTES}/${routeId}/geoWayPoints`,
                            };
                            const iHttpService = ObjectFactory.getHttpService();
                            const geoWayPointResponse = await iHttpService.get<any>(apiRequest);
                            if (geoWayPointResponse.success && geoWayPointResponse.data &&
                                geoWayPointResponse.data.length > 0) {
                                this.completedRouteDetails[index] = geoWayPointResponse.data;
                                this.showRoutePolyLine = true;
                            }
                            index++;
                        });
                    }
                }
                this.isRouteLoading = false;
            }
        }
    }

    private async getCustomerLog() {
        const requestId = this.$props.id || this.$route.params.id;
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${requestId}/events`,
        };
        const response = await iHttpService.get<any>(apiRequest);
        if (response.data) {
            response.data.forEach((element: any) => {
                element.timestamp = DateUtils.formatDate(
                element.timestamp,
                DateUtils.FORMAT_DATETIME_AM_PM,
            );
        });
            this.requestEvents = response.data;
            this.setCurrentStatusTimestamp();
        }
    }

    private async approveRequest() {
        const requestId = this.$props.id || this.$route.params.id;
        await ObjectFactory.getRequestService().approveRequest(requestId, this.$store.state.serverUrl);
        this.redirectToList('Pending');
    }

    private async cancelRequest(request?: any) {
        const cancelRequest: CancelRequest = {
            reason: this.$data.cancellationReason,
            comments: this.$data.comments,
        };
        const response = await ObjectFactory.getRequestService().cancelRequest(
            request.id, cancelRequest, this.$store.state.serverUrl);
        if (response.success) {
            this.redirectToList('Canceled');
        }
        this.$data.cancellationReason = '';
        this.$data.comments = '';
        this.showCancelationReasonModal = false;
    }

    private redirectToList(status: RequestStatus) {
        let requestType = 'interpreterRequest';
        if (this.serviceRequest && this.serviceRequest.transportRequest) {
            requestType = 'transportRequest';
        } else if (this.serviceRequest && this.serviceRequest.telemedicineRequest) {
            requestType = 'telemedicineRequest';
        }
        this.$router.push({
            path: `${MedTransGoConstants.URL_REQUESTS}/${this.serviceRequest.id}`,
            query: { requestType, status },
        });
        this.getRequestDetails(true);
    }

    private async changeInterpreter() {
        if (this.serviceRequest.id) {
            const response = await ObjectFactory.getRequestService()
                .changeInterpreter(this.serviceRequest.id, this.$store.state.serverUrl);
            if (response.success) {
                this.redirectToList('Pending');
                this.showChangeInterpreterConfirmation = false;
            }
        }
    }

    private addParticipant() {
        if (this.participants && this.$v.participantEmail.email) {
            if (!this.participants.includes(this.$data.participantEmail)) {
                this.participants.push(this.$data.participantEmail);
            }
            this.$data.participantEmail = '';
            this.validateForm();
        }
    }

    private removeParticipant(index: number) {
        if (this.participants) {
            this.participants.splice(index, 1);
            this.validateForm();
        }
    }

    private validateForm() {
        if (this.participants) {
            this.isFormValid = this.participants.length > 0;
        }
    }

    private async editParticipant() {
        if (this.participants && this.participants.length) {
            const requestId: string = this.serviceRequest.id as any;
            const editParticipantRequest: EditParticipantRequest = {
                participants: this.participants,
            };
            const response = await ObjectFactory.getRequestService().editRequest(
                requestId, editParticipantRequest, this.$store.state.serverUrl);
            if (response) {
                this.getRequestDetails(true);
            }
        }
    }

    private async getLienRequestDocuments(showLoader: boolean) {
        const requestId = this.$props.id || this.$route.params.id;
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${requestId}/lienDocuments`,
        };
        if (showLoader) {
            apiRequest.loaderEvent = {
                show: true,
            };
        }
        const response = await iHttpService.get<Document[]>(apiRequest);
        if (response.data && response.data.length) {
            for (const document of response.data) {
                document.status = document.verified ? 'Verified and Approved' : 'Signed and Awaiting Verification';
                if (!document.resourceId) {
                    document.status = 'Needs Signature';
                }
                if (document.rejected) {
                    document.status = 'Rejected';
                }
                document.state = this.pickUpAddressState;
            }
            this.lienDocumentTable.data = response.data;
            if (this.serviceRequest.transportRequest && this.serviceRequest.transportRequest.lienRequest) {
                this.lienDocumentTable.data.isLienRequest = true;
            }
        }
    }

    private viewLienDocument(document: Document) {
        this.selectedDocument = document;
    }

    private async getProofOfDelivery(fileName: string) {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/download/${fileName}`,
            loaderEvent: {
                show: true,
            },
            responseType: 'arraybuffer',
        };
        const fileBuffer = await iHttpService.get<any>(apiRequest) as any;
        if (fileBuffer.errorCode) {
            CommonUtils.showError(fileBuffer);
        } else {
            const file = new Blob([fileBuffer], { type: 'application/pdf' });
            this.$data.blobURL = URL.createObjectURL(file);
        }
    }

    private async openStatusTab() {
        if (this.$data.activeTabIndex !== 2 || this.$data.activeTabIndex !== 3 ) {
            this.$data.activeTabIndex = this.invoice ? 3 : 2;
        }

        const element = document.getElementById('requestTabs') as Element;
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    private async getDocumentSigningLink() {
        const requestId = this.$props.id || this.$route.params.id;
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${requestId}/signingLink`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<string>(apiRequest);
        if (response.success && response.data) {
            this.$data.showSignowPopup = true;
            this.$data.documentSigningLink = response.data;
        } else {
            CommonUtils.showError(response);
        }
        return response;
    }

    private async getResource(resourceId: string): Promise<any> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/${resourceId}`,
        };
        const response = await iHttpService.get<any>(apiRequest);
        if (response.success && response.data) {
            return response.data;
        }
    }

    private async confirmUpdate() {
        this.confirmUpdateLink = true;
        this.dialogVisible = false;
    }

    private async submitLink() {
        const id = this.$props.id || this.$route.params.id;
        const trimmedLink = this.$data.joinLink.trim();
        if (!/^https?:\/\//.test(trimmedLink)) {
            this.$data.joinLink = /^https?:\/\//.test(trimmedLink) ? trimmedLink : 'http://' + trimmedLink;
        } else {
            this.$data.joinLink = trimmedLink;
        }
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${id}/joinLink`,
            data: { joinLink: this.$data.joinLink },
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<number>(apiRequest);
        if (response.success) {
            this.getRequestDetails(true);
            this.$data.joinLink = '';
            this.confirmUpdateLink = false;
            const toastEvent: ToastEvent = {
                message: 'Meeting link update successfully.',
                title: 'Success',
                varient: 'primary',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
            this.confirmUpdateLink = false;
        }
    }

    private async handleCancel() {
        this.$data.joinLink = '';
        this.confirmUpdateLink = false;
        this.acknowledged = false;
    }

    private async handleRescheduleRequestClick() {
        if (this.$route.path.includes('reports') || this.$route.path.includes('calendar') ) {
            this.activeTab = true;
            this.showRescheduleRequestModal = true;
        } else {
            this.$router.push({ path: 'reschedule', append: true, query: this.$route.query });
        }
    }

    private handleEditServiceRequest() {
        if (this.$route.path.includes('reports') || this.$route.path.includes('calendar') ) {
            this.activeTab = true;
            this.showEditRequestModal = true;
        } else {
            this.$router.push({ path: 'update', append: true, query: this.$route.query });
        }
    }

    private getWheelchairMessage(providedWheelchairOption: any) {
        if (providedWheelchairOption === 'NeedsReturn') {
            return 'I am providing a wheelchair that needs to be returned.';
        } else if (providedWheelchairOption === 'TransporterProvides') {
            return 'The transporter should provide a wheelchair for this patient.';
        }
    }

    private animateCarIcon(
        startLocation: GPSLocation,
        endLocation: GPSLocation,
        updateCallback: (location: GPSLocation, isFinalPosition: boolean) => void,
    ) {
        const totalDuration = 2000; // Adjust for desired animation speed
        const distanceLatitude = endLocation.latitude - startLocation.latitude;
        const distanceLongitude = endLocation.longitude - startLocation.longitude;
        const thresholdDistance = 0.0001; // Minimum distance change to trigger re-centering
        let lastCenterUpdate = startLocation;

        const animate = (startTime: number) => {
            const currentTime = performance.now();
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / totalDuration, 1); // Clamp progress between 0 and 1

            // Interpolate latitude and longitude for smooth transition
            const currentLatitude = startLocation.latitude + distanceLatitude * progress;
            const currentLongitude = startLocation.longitude + distanceLongitude * progress;
            const currentPosition = { latitude: currentLatitude, longitude: currentLongitude };

            // Update car icon position
            const isFinalPosition = progress === 1;
            updateCallback(currentPosition, isFinalPosition);

            // Re-center map only if it's the final position or the icon has moved significantly
            const distanceMoved = Math.sqrt(
                Math.pow(currentLatitude - lastCenterUpdate.latitude, 2) +
                Math.pow(currentLongitude - lastCenterUpdate.longitude, 2),
            );

            if (isFinalPosition || distanceMoved > thresholdDistance) {
                // Update the last re-center position to avoid frequent updates
                lastCenterUpdate = currentPosition;
            }

            // Continue animation if not completed
            if (progress < 1) {
                requestAnimationFrame(() => animate(startTime));
            }
        };
        requestAnimationFrame((startTime) => animate(startTime));
    }

    private async viewTextMessage(message: any) {
        this.selectedTextMessage = message;
        this.showTextMessagePopup = true;
    }

    private convertUrlsToLinks(text: string): string {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, (url) => {
        return `<a href="${url}" target="_blank" class="text-primary">${url}</a>`;
        });
    }

    private setCurrentStatusTimestamp() {
        const statusKeywords: Record<string, string[]> = {
            'Pending Payment': ['Pending Payment'],
            'Requires Approval': ['Requires Approval'],
            'Pending': ['status changed to Pending'],
            'Confirmed': ['status changed to Confirmed'],
            'Completed': ['status changed to Completed', 'Request completed'],
            'Canceled': ['status changed to Canceled', 'Request canceled'],
            'Documents Sent': ['Documents Sent'],
            'Documents Signed': ['Documents Signed'],
        };
        const keywords = statusKeywords[this.currentStatus] || [this.currentStatus];
        const matchedEvent = [...this.requestEvents]
            .reverse().find((event) => keywords.some((keyword) =>
                    event.message.toLowerCase().includes(keyword.toLowerCase())));
        if (matchedEvent) {
            this.currentStatusTimestamp = DateUtils.formatDate(
                matchedEvent.timestamp,
                'dddd Do MMMM, YYYY h:mm a z',
            );
        } else {
            const latestVisible = this.requestEvents
                .filter((e: any) => e.isVisibleToCustomer)
                .sort((a: any, b: any) =>
                        new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())[0];
            const eventTime = latestVisible
                ? DateUtils.formatDate(latestVisible.timestamp, 'dddd Do MMMM, YYYY h:mm a z')
                : null;
            if (eventTime) {
                this.currentStatusTimestamp = eventTime;
            }
        }
    }

}
